import { Col, DatePicker, Input, Row, Select } from 'antd';
import React, { useMemo, useState } from 'react';
//import locale from "antd/lib/date-picker/locale/it_IT";
import { IMoment, Moment } from '../../../utils/helpers/date_helpers';
const { Option } = Select;
export const DateTypes = [
  { label: 'Compresa', value: 'range' },
  { label: 'Maggiore di', value: 'gt' },
  { label: 'Minore di', value: 'lt' },
];

export type DateType = 'range' | 'eq' | 'gt' | 'lt';
interface DateRangeProps {
  name?: string;
  placeholder?: string;
  defaultValue?: any;
  onChanged?: (any) => any;
  format?: string;
  showToday?: boolean;
  value?: any;
  returnFormat?: string;
  onChange?: any;

  /**return only date and to type */
  returnOnlyDate?: boolean;

  /**  range = data rage | gt = Maggiore di | lt = Minore di */
  rangeType?: DateType;
  changeType?: boolean;
  onChangeType?: (type: DateType) => void;
}
const DateRange: React.FC<DateRangeProps> = React.forwardRef(
  (
    {
      placeholder = 'Data',
      onChanged,
      showToday = false,
      name,
      rangeType = 'range',
      format = 'DD/MM/YYYY',
      returnFormat = undefined,
      changeType = true,
      onChange,
      onChangeType = undefined,
      returnOnlyDate = false,
      ...props
    },
    ref
  ) => {
    const [dateType, setDateType] = useState(rangeType);
    const internalChange = (momentDate: IMoment | IMoment[], dateStrings) => {
      if (returnOnlyDate) return onChange && onChange(momentDate);

      let newDate: any = momentDate;

      if (Array.isArray(momentDate)) {
        newDate = momentDate.map((val) => (returnFormat ? val.format(returnFormat) : val));
      } else {
        newDate = returnFormat ? momentDate.format(returnFormat) : momentDate;
      }

      const theValue = {
        date: newDate,
        type: dateType,
      };
      onChange && onChange(theValue);
    };

    const valueDate = useMemo(() => {
      let { date = undefined, type = dateType } = props?.value || {};
      if (returnOnlyDate) date = props?.value || undefined;
      if (type === 'range') {
        if (!date || date === 'Invalid date') return [,];

        if (Array.isArray(date)) {
          return date.map((val) => (!Moment.isMoment(val) ? Moment(val, format) : val));
        }

        return date;
      }
      return date && !Moment.isMoment(date) ? Moment(date, format) : date || undefined;
    }, [props.value, rangeType, dateType]);

    const changeDateType = (newType) => {
      setDateType(newType);
      onChange && onChange(undefined);
      onChangeType && onChangeType(newType);
    };

    // const _placeholder = useMemo(() => {
    //   if (dateType !== 'range') {
    //     if (dateType === 'gt') return `${placeholder} maggiore o uguale di`;
    //     if (dateType === 'lt') return `${placeholder} minore o uguale di`;
    //   } else {
    //     return placeholder;
    //   }
    // }, [dateType]);

    return (
      <div>


        <Input.Group>
          <Row wrap={false}>
            {changeType && (
              <Col>
                <Select value={dateType} onChange={changeDateType}>
                  <Option value="range">
                    compresa tra
                    {/* <CommonIcons icon="calendar-alt" style={{ fontSize: 10 }} /> */}
                  </Option>
                  <Option value="eq">
                    uguale a
                    {/* <CommonIcons icon="greater-than-equal" style={{ fontSize: 10 }} /> */}
                  </Option>
                  <Option value="gt">
                    maggiore di
                    {/* <CommonIcons icon="greater-than-equal" style={{ fontSize: 10 }} /> */}
                  </Option>
                  <Option value="lt">
                    minore di
                    {/* <CommonIcons icon="less-than-equal" style={{ fontSize: 10 }} /> */}
                  </Option>
                </Select>
              </Col>
            )}

            <Col flex={1}>

            </Col>
          </Row>
        </Input.Group>
      </div>
    );
  }
);

export default DateRange;
